<template>
  <v-form>
    <v-container>
      <v-layout row wrap>
        <slot></slot>
      </v-layout>
    </v-container>
  </v-form>
</template>

<script>
export default {};
</script>

<style>
</style>
